import * as React from 'react';
import { useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackCategoriesShow } from './tracking';
import { Categories } from '../../components/Categories';
import { selectPage } from '../../selectors/analytics';
import { selectCategories } from '../../selectors/promosPage';
import { ICategory } from '../../types/promosPage';
import { trackClickCategories } from '../../utils/analytics';

export const CategoriesContainer = () => {
  const categories = useSelector(selectCategories);
  const page = useSelector(selectPage);

  const handleAfterView = React.useCallback(() => {
    trackCategoriesShow(page);
  }, [page]);

  const handleClick = React.useCallback((category: ICategory) => {
    trackClickCategories({
      type: 'bottom_categories',
      searchConditions: category.queryString,
    });
  }, []);

  if (categories.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleAfterView}>
      <Categories categories={categories} onCategoryClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
